// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__18YaC","amount":"Amount_amount__-Ev--","tip":"Amount_tip__PzHj2","tipHeader":"Amount_tipHeader__1HrbR","tipsWrap":"Amount_tipsWrap__3Futq"};